import { render, staticRenderFns } from "./LayoutWithoutSidenav.vue?vue&type=template&id=191c840d&"
import script from "./LayoutWithoutSidenav.vue?vue&type=script&lang=js&"
export * from "./LayoutWithoutSidenav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWithoutSidenav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports